import React, { useState, useRef,useEffect } from "react";
import { Box, Typography, Avatar, Popover, Button, CircularProgress, TextField } from "@mui/material";
import axios from "axios";
import UserDefaultImage from "../../assets/User Default Image.png";
import { useTheme } from "../../style/theme";
import { useUser } from "../../hooks/Authorize";

const UserInfoMenu = ({ item, anchorEl, onClose }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [sendStatus, setSendStatus] = useState(null);
  const userCache = useRef({});
  const { mode } = useTheme();
  const platformUser = JSON.parse(localStorage.getItem("user"));

 
  useEffect(() => {
    let timer;
    if (sendStatus) {
      timer = setTimeout(() => {
        setSendStatus(null);
      }, 3000); // 3 seconds
    }
    return () => clearTimeout(timer); // Cleanup on unmount
  }, [sendStatus]);

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (!item?.ownerId || !anchorEl) return;

      setLoading(true);
      try {
        const res = await axios.get(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/getUsers`, {
          params: { ids: [item.ownerId] },
        });
        const data = res.data;
        userCache.current[item.ownerId] = data;
        console.log('data = ',data)
        setUserInfo(data[0]);
      } catch (error) {
        console.error("Failed to fetch user info", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, [anchorEl, item]);

  const handleSendMail = async () => {
    if (!message.trim()) {
      setSendStatus("Please enter a message");
      return;
    }

    setSending(true);
    setSendStatus(null);

    var payload = {
      resourceId: item._id,
      sender: platformUser.email,
      receiver: item.ownerEmail, // Assuming userInfo contains the email
      message: message,
      subject: `Message from ${platformUser.email}`,
      baseUrl: window.location.origin,
    }
    console.log("payload = ", payload)
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/send-mail`,
        payload
      );
      console.log(response)


      setSendStatus("Message sent successfully!");
      setMessage("");
    } catch (error) {
      console.error("Failed to send mail", error);
      setSendStatus("Failed to send message. Please try again.");
    } finally {
      setSending(false);
    }
  };

 

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      disableRestoreFocus
      onClick={(e) => e.stopPropagation()}
      PaperProps={{
        sx: {
          width: "280px",
          borderRadius: "12px",
          padding: "4px 0",
          boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
          background: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",
        },
      }}
    >
      <Box p={2} width={280}>
        {loading ? (
          <CircularProgress size={24} />
        ) : userInfo ? (
          <>
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar src={UserDefaultImage} />
              <Box>
                <Typography variant="subtitle1">
                  {userInfo.firstName} {userInfo.lastName}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {userInfo.email}
                </Typography>
              </Box>
            </Box>

           {platformUser.email!==item.ownerEmail && <Box my={1}>
              <TextField
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                placeholder="Type your message here..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                sx={{
                  mb: 1,
                  '& .MuiInputBase-input': {
                    fontSize: '0.875rem' // This sets the font size to 14px
                  }
                }}
              />
              {sendStatus && (
                <Typography
                  variant="body2"
                  color={sendStatus.includes("success") ? "success.main" : "error.main"}
                  sx={{ mb: 1 }}
                >
                  {sendStatus}
                </Typography>
              )}
              <Box display="flex" justifyContent="space-between">
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleSendMail}
                  disabled={sending}
                >
                  {sending ? <CircularProgress size={20} /> : "Send Mail"}
                </Button>
                {/* <Button size="small">Message</Button> */}
              </Box>
            </Box>}
          </>
        ) : (
          <Typography>No user data</Typography>
        )}
      </Box>
    </Popover>
  );
};

export default UserInfoMenu;